import * as Localization from 'expo-localization';
import _ from 'lodash';

const HelperLocale = {

	getDeviceLocale: () => {
		let deviceLocale = Localization.locale;
		
		switch( true ) {
			case _.startsWith( deviceLocale, 'en-' ):
				deviceLocale = 'en-GB';
				break;
				
			case _.startsWith( deviceLocale, 'nl-' ):
				deviceLocale = 'nl-NL';
				break;
				
			default:
				deviceLocale = 'en-GB';
		}
		
		return deviceLocale;
	},
	
	localeSubstr( lng ) {
		return lng.substr( 0, lng.indexOf('-') );
	},
}

export default HelperLocale;
